import { DefaultValues } from 'react-hook-form';

import { MERCHANTS_FILTER_DEFAULT_VALUES, MerchantsFilterValues } from '../MerchantsListFilter';

export const merchantsFilterMapper = {
  fromUrl: (filterValues: Record<string, any>): DefaultValues<MerchantsFilterValues> => ({
    archive: filterValues.archive ?? MERCHANTS_FILTER_DEFAULT_VALUES.archive,
    name: filterValues.name ?? MERCHANTS_FILTER_DEFAULT_VALUES.name,
    companies: filterValues.companies ?? MERCHANTS_FILTER_DEFAULT_VALUES.companies,
    partner: filterValues.partner ?? MERCHANTS_FILTER_DEFAULT_VALUES.partner,
    platform: filterValues.platform ?? MERCHANTS_FILTER_DEFAULT_VALUES.platform,
    referrals: filterValues.referrals ?? MERCHANTS_FILTER_DEFAULT_VALUES.referrals,
  }),
};
